/**
 * Created by Artagan on 11.11.16.
 */
(function () {
    $('.form-newsletter').each(function() {
        const $form = $(this);
        const $formGroup = $form.find('.form-group');

        const $email     = $formGroup.find('input[name=email]');
        const $agreement = $formGroup.find('input[name=agreement]');

        $form.on('submit', function(e) {
            e.preventDefault();

            $formGroup.removeClass(['has-error', 'has-success']);

            if ($email.val() === '') {
                $formGroup.find('.error-message').html('Nastal zkrat. Vyplňte správnou e-mailovou adresu.');
                $formGroup.addClass('has-error');
                return;
            }

            if ($agreement.length > 0 && !$agreement.is(':checked')) {
                $formGroup.find('.error-message').html('Nastal zkrat. Musíte souhlasit s podmínkami.');
                $formGroup.addClass('has-error');
                return;
            }

            $.post('/subscribe-email', {
                email: $email.val()
            }).success(function(result) {
                if (result && result.status == 'success') {
                    $formGroup.addClass('has-success');

                    dataLayer.push({
                        'event':     'ga.event',
                        'eCategory': $('body').data('ga-category') || 'Neznámá',
                        'eAction':   'Přihlášení',
                        'eLabel':    $form.data('ga-label') || 'Newsletter'
                    });
                    return;
                }

                $formGroup.addClass('has-error');

                if (result && result.message) {
                    $formGroup.find('.form-message-error').html(result.message);
                }

            }).error(function() {
                $formGroup.addClass('has-error');
            })
        });
    });
})();



// WEBPACK FOOTER //
// ./app/Resources/assets/js/scripts/newsletter.js